import axios from "axios";
import { Logger } from "../../logging/logger";

const baseUrl = "https://product-page-v2-bff-database.prod.merch.vpsvc.com";

export const updateMsxData = async (props: {
  tenant: string;
  locale: string;
  productKey: string;
  version: number;
}): Promise<string> => {
  const { tenant, locale, productKey, version } = props;

  const url = `${baseUrl}/v1/update-msx-data/${tenant}/${locale}/${productKey}/${version}`;
  try {
    const result = await axios.post(url);
    return result.data;
  } catch (e) {
    const errorMessage = "Failed to update msx data";
    const message = `${errorMessage}: tenant: ${tenant}, locale: ${locale}, productKey: ${productKey}, version: ${version}.`;
    Logger.instance.error(errorMessage, {
      tenant,
      locale,
      productKey,
      version,
      url,
      error: e,
    });
    return message;
  }
};
